import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const reportsApi = {
    /**
     * Obtiene listado de clientes
     */
    getClients: async (token) => {
        const res = await axios.get(`${API}/clients`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { limit: 1000 }
        });
        return res.data?.items || res.data;
    },

    /**
     * Obtiene listado de marcas con filtros
     */
    getTrademarks: async (token, filters = {}) => {
        const params = {
            is_active: true,
            limit: 1000
        };

        // Apply client filter
        if (filters.client && filters.client !== 'all') {
            params.client_id = filters.client;
        }

        // Note: 'period' and 'risk' filtering happens on frontend 
        // because backend list_trademarks doesn't support date ranges or computed risk.

        const res = await axios.get(`${API}/trademarks`, {
            headers: { Authorization: `Bearer ${token}` },
            params
        });
        return res.data?.items || res.data;
    },

    /**
     * Obtiene listado de procedimientos con filtros
     */
    getProcedures: async (token, filters = {}) => {
        const params = { limit: 1000 };

        if (filters.client && filters.client !== 'all') {
            params.client_id = filters.client;
        }

        const res = await axios.get(`${API}/procedures`, {
            headers: { Authorization: `Bearer ${token}` },
            params
        });
        return res.data?.items || res.data;
    }
};
